export default "__VITE_ASSET__fa353cbb__"